import Axios from '../lib/axios'
import AxiosForMobile from '../lib/axios_for_mobile'
class StatisticsService {
  async seizureGraph (patientId, filters) {
    const result = await Axios.authenticated().get(`/statistics`, {
      params: {
        patientId: patientId,
        filters: filters
      }
    })
    return result
  }

  async seizureGraphForMobile (patientId, lang, filters) {
    const result = await AxiosForMobile.authenticated().get(`/b/statistics`, {
      params: {
        patientId: patientId,
        lang: lang,
        filters: filters
      }
    })
    return result
  }

  async getActivity (filters) {
    const result = await Axios.authenticated().get(`/statistics/user-activity`, {
      params: filters
    })
    return result
  }

  async exportToPdf (html) {
    const result = await Axios.authenticated().post(
      `/statistics/export`,
      {
        'html': html
      },
      {responseType: 'arraybuffer'}
    )
    return result
  }

  async exportToPdfFromMobile (html) {
    const result = await AxiosForMobile.authenticated().post(`/b/statistics/export`,
      {
        'html': html
      },
      {responseType: 'arraybuffer'}
    )
    return result
  }
}

export default new StatisticsService()
